import { Row } from '@opendoor/atoms/box';
import { Button } from '@opendoor/atoms/button';
import { Dialog } from '@opendoor/atoms/dialog';
import { Text } from '@opendoor/atoms/text';

const ExitOfferDialog = ({
  open,
  leaving,
  error,
  onStay,
  onLeave,
}: {
  open: boolean;
  leaving: boolean;
  error: string | null;
  onStay: () => void;
  onLeave: () => Promise<void>;
}) => {
  const handleOpenChange = (nextOpen: boolean) => {
    if (!nextOpen) onStay();
  };

  return (
    <Dialog.Root role="alertdialog" open={open} onOpenChange={handleOpenChange}>
      <Dialog title="Leave this offer?" size="sm" hideCloseButton>
        <Dialog.Description className="text-body-md text-od-content-secondary">
          Your offer hasn’t been submitted. Do you want to leave this flow?
        </Dialog.Description>
        {error ? (
          <Text role="alert" className="pt-3 text-body-sm text-od-content-error">
            {error}
          </Text>
        ) : null}
        <Row className="flex-wrap justify-end gap-2 pt-6">
          <Button
            type="button"
            variant="primary"
            size="md"
            onClick={onStay}
            disabled={leaving}
            aria-label="Stay in offer"
            analyticsName="cosmos-make-offer-cancel-exit"
          >
            Stay in offer
          </Button>
          <Button
            type="button"
            variant="secondary"
            size="md"
            onClick={onLeave}
            disabled={leaving}
            loading={leaving}
            aria-label="Leave offer"
            analyticsName="cosmos-make-offer-confirm-exit"
          >
            Leave offer
          </Button>
        </Row>
      </Dialog>
    </Dialog.Root>
  );
};

export default ExitOfferDialog;
